import { axiosInstance } from "@/api/apiClient";
import {
  PurchaseApi,
  PurchaseApiPaymentsViewsNinjaPurchaseAddonPurchaseWebRequest,
  PurchaseApiPaymentsViewsNinjaPurchaseAddonPurchaseWebV2Request,
  PurchaseApiPaymentsViewsNinjaPurchaseAuthAddonPurchaseRequest,
  PurchaseApiPaymentsViewsNinjaPurchaseAuthNumberPurchaseRequest,
  PurchaseApiPaymentsViewsNinjaPurchaseGenerateBusinessNumberExtensionPaymentLinkRequest,
  PurchaseApiPaymentsViewsNinjaPurchaseGetAddonPlansRequest,
  PurchaseApiPaymentsViewsNinjaPurchaseGetSubscriptionPlanRequest,
  PurchaseApiPaymentsViewsNinjaPurchaseNewWebPaymentPagePurchaseRequest,
  PurchaseApiPaymentsViewsNinjaPurchaseNumberAndAddonPurchaseWebRequest,
  PurchaseApiPaymentsViewsNinjaPurchaseWebPaymentPagePurchaseRequest,
} from "@/api/client";
import { CustomAxiosRequestConfig } from "@/api/types";
import { BASE_API } from "@/helpers/constants";

const api = new PurchaseApi(undefined, BASE_API, axiosInstance);

export const getSubscriptionPlan = async (
  payload: PurchaseApiPaymentsViewsNinjaPurchaseGetSubscriptionPlanRequest
) => {
  return api.paymentsViewsNinjaPurchaseGetSubscriptionPlan.bind(api)(payload, {
    accessLevel: "public",
  } as CustomAxiosRequestConfig);
};

export const webPaymentPurchase = async (
  payload: PurchaseApiPaymentsViewsNinjaPurchaseWebPaymentPagePurchaseRequest
) => {
  return api.paymentsViewsNinjaPurchaseWebPaymentPagePurchase.bind(api)(
    payload,
    { accessLevel: "public" } as CustomAxiosRequestConfig
  );
};

export const webPaymentPurchaseV2 = async (
  payload: PurchaseApiPaymentsViewsNinjaPurchaseNewWebPaymentPagePurchaseRequest
) => {
  return api.paymentsViewsNinjaPurchaseNewWebPaymentPagePurchase.bind(api)(
    payload,
    { accessLevel: "public" } as CustomAxiosRequestConfig
  );
};

export const getAddonPlans = async (
  payload: PurchaseApiPaymentsViewsNinjaPurchaseGetAddonPlansRequest
) => {
  return api.paymentsViewsNinjaPurchaseGetAddonPlans.bind(api)(payload, {
    accessLevel: "public",
  } as CustomAxiosRequestConfig);
};

export const purchaseNumberAndAddon = async (
  payload: PurchaseApiPaymentsViewsNinjaPurchaseNumberAndAddonPurchaseWebRequest
) => {
  return api.paymentsViewsNinjaPurchaseNumberAndAddonPurchaseWeb.bind(api)(
    payload,
    { accessLevel: "public" } as CustomAxiosRequestConfig
  );
};

export const purchaseAuthAddon = async (
  payload: PurchaseApiPaymentsViewsNinjaPurchaseAuthAddonPurchaseRequest
) => {
  return api.paymentsViewsNinjaPurchaseAuthAddonPurchase.bind(api)(payload);
};

export const purchaseAddon = async (
  payload: PurchaseApiPaymentsViewsNinjaPurchaseAddonPurchaseWebRequest
) => {
  return api.paymentsViewsNinjaPurchaseAddonPurchaseWeb.bind(api)(payload, {
    accessLevel: "public",
  } as CustomAxiosRequestConfig);
};

export const purchaseAuthNumber = async (
  payload: PurchaseApiPaymentsViewsNinjaPurchaseAuthNumberPurchaseRequest
) => {
  return api.paymentsViewsNinjaPurchaseAuthNumberPurchase.bind(api)(payload);
};

export const purchaseNumberExtensionPaymentLink = async (
  payload: PurchaseApiPaymentsViewsNinjaPurchaseGenerateBusinessNumberExtensionPaymentLinkRequest
) => {
  return api.paymentsViewsNinjaPurchaseGenerateBusinessNumberExtensionPaymentLink.bind(
    api
  )(payload, {
    accessLevel: "public",
  } as CustomAxiosRequestConfig);
};

export const purchaseAddonV2 = async (
  payload: PurchaseApiPaymentsViewsNinjaPurchaseAddonPurchaseWebV2Request
) => {
  return api.paymentsViewsNinjaPurchaseAddonPurchaseWebV2.bind(api)(payload, {
    accessLevel: "public",
  } as CustomAxiosRequestConfig);
};
